import { createSelector } from 'reselect'
import _ from 'lodash'
import { formatTimeHMS } from 'Helper/timeHelper'

const selectEpochTime = (state) => state.timer.movement.epochTime
const selectInstances = (state) => state.timer.instances
const instanceSort = (a, b) => a.timeRemaining - b.timeRemaining

export const selectCalculatedTimers = createSelector(
  selectEpochTime,
  selectInstances,
  (epochTime, instances) => {
    return instances.map((instance) => {
      const timeElapsed = (epochTime - instance.start_time)
      const timeRemaining = (instance.start_time + instance.duration_seconds - epochTime)
      const progress = (timeElapsed / instance.duration_seconds)
      const isAlarming = (timeRemaining <= 0)
      const isAlmostAlarming = (timeRemaining <= 60)
      return {
        ...instance,
        timeElapsed,
        timeRemaining,
        formattedTime: formatTimeHMS(timeRemaining),
        progress,
        isAlarming,
        isAlmostAlarming,
      }
    }).sort(instanceSort)  // also order by expiring first
  }
)

export const selectAreTimersAlarming = createSelector(
  selectCalculatedTimers,
  // (instances) => _.sumBy(instances, (instance) => (instance.isAlarming == true))  // count of alarming timers
  (instances) => instances.find((instance) => (instance.isAlarming == true)) ? true : false
)

export const selectTimerById = (state, timer_id) => {
  return _.find(selectCalculatedTimers(state), {timer_id})
}

export const selectTimerIsShowingOptions = (state, contextView, timer_id) => {
  return (state.timer.showOptionsOnId[contextView] === timer_id)
}
